import React from "react"
import Layout from "../Layout"
import Contact from "../Contact"
import Gallery from "../Gallery"
import Hero from "../Hero"
import Numbers from "../Numbers"
import Summary2025 from "../Summary2025"

const IndexPage = ({ lang }) => (
  <Layout lang={lang}>
    <Hero lang={lang} type="hero2025" />
    <Numbers lang={lang} type="summary2025" />
    <Gallery lang={lang} />
    <Summary2025 lang={lang} />
    <Contact lang={lang} />
  </Layout>
)

export default IndexPage
